import { AbstractSubmitStep } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import {
	faArrowRight as fasArrowRight,
	faCircleCheck as fasCircleCheck,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { List, ProgressButton } from "bm-ui-kit";
import type { FormApi } from "final-form";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

interface StepFields {}

export class Result extends AbstractSubmitStep<StepFields> {
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;

		return (
			<>
				<Card.Body>{this.renderResult()}</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
						state={submitState}
					>
						Kérem a részletes tájékoztatót
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	private renderResult(): ReactNode {
		return (
			<>
				<div className="text-center my-3">
					<FontAwesomeIcon icon={fasCircleCheck} className="text-success" size="4x" />
				</div>
				<p>
					Az elérhető <strong>faktor finanszírozás</strong> részleteit e-mailben küldjük meg a számodra:
				</p>
				<List itemStyle="tick" variant="primary">
					<List.Item>
						Milyen <strong>összegben</strong> kaphat finanszírozást (megelőlegezést) a céged?
					</List.Item>
					<List.Item>
						<strong>Mennyi idő</strong> alatt?
					</List.Item>
					<List.Item>
						<strong>Várhatóan milyen költség</strong> mellett?
					</List.Item>
					<List.Item>
						<strong>Mitől függhet</strong> a finanszírozás mértéke?
					</List.Item>
				</List>
				<div className="text-center pt-3">
					A Bankmonitor szakértője teljeskörű támogatást nyújt hiteligényedhez!
				</div>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
